import React from 'react';
import { CardContent, Typography } from '@mui/material';

const OfferContent = ({ children }) => {
  const content = String(children ?? '');

  return (
    <CardContent
      sx={(theme) => ({
        paddingBottom: 0,
        paddingTop: 0,
        flex: '1 1 40px',
        overflow: 'hidden',
        marginBottom: theme.spacing(1),
      })}
    >
      <Typography variant="body2" color="textSecondary" component="p">
        {content.length > 150 ? `${content.slice(0, 150)}...` : content}
      </Typography>
    </CardContent>
  );
};

export default OfferContent;
